import { differenceInYears, parseISO } from "date-fns";
import { isDateAfterOrSameDay } from "./dateUtils";


export const getClientTypeFromClientNumber = (clientId: string): "child" | "adult" => {
    const lastChar = clientId.toLowerCase().slice(-1);
    const clientType = lastChar === 'c' ? 'child' : 'adult';
    return clientType;
};

export const getIntakeFormTypeFromClientNumber = (clientId: string): "intake_forms_child" | "intake_forms_adult" => {
    const clientType = getClientTypeFromClientNumber(clientId);
    return clientType === 'child' ? 'intake_forms_child' : 'intake_forms_adult';
};

export const isClientLessThan18YearsOld = (dateString: string): boolean => {
    const parsedDate = parseISO(dateString);
    const currentYear = new Date();
    const age = differenceInYears(currentYear, parsedDate);
    return age < 18;
};

export const getClientCurrentAge = (clientBirthDate: string) => {
    const birthDate = parseISO(clientBirthDate);
    const today = new Date();
    const currentAge = differenceInYears(today, birthDate);
    return currentAge;
};

export const getClientAgeAtTreatment = (clientBirthDate: string, treatmentCreatedDate: string, treatmentAgeWhenStarted: number | null | undefined) => {
    if (treatmentAgeWhenStarted !== null && treatmentAgeWhenStarted !== undefined) {
        return treatmentAgeWhenStarted;
    }
    const birthDate = parseISO(clientBirthDate);
    const createdDate = parseISO(treatmentCreatedDate);
    const ageAtCreation = differenceInYears(createdDate, birthDate);
    return ageAtCreation;
};

export const getIntakeFormTypeFromAge = (clientAge: number): "child" | "adult" => {
    const cutoffDate = new Date(2026, 1, 24, 8, 0, 0);
    const today = new Date();
    if (isDateAfterOrSameDay(today, cutoffDate)) {
        // because if client is 18, although its an adult it receives the child intakeform
        return clientAge >= 19 ? "adult" : "child";
    }
    // for backwards compatibility we keep the previous logic for previous filled forms
    return clientAge >= 18 ? "adult" : "child";
};

